import { useEffect, useState } from "react";
import { ClipboardCheck } from "lucide-react";
import api from "../lib/api";
import { Loader, Pill } from "../components/common";

export default function Checkins() {
  const [checkins, setCheckins] = useState(null);
  useEffect(() => { api.get("/coach/checkins").then(({ data }) => setCheckins(data)); }, []);
  if (!checkins) return <Loader />;

  return (
    <div className="p-6 lg:p-8">
      <h1 className="font-heading text-5xl">Check-Ins</h1>
      <p className="text-secondary mt-1">Weekly reflections from your customers.</p>
      <div className="grid md:grid-cols-2 gap-4 mt-6 max-w-4xl">
        {checkins.map((ch) => (
          <div key={ch.id} className="card-surface rounded-xl p-5" data-testid="checkin-card">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2"><div className="w-9 h-9 rounded-full bg-brand/20 flex items-center justify-center font-heading text-brand">{ch.customer_name[0]}</div><span className="font-semibold">{ch.customer_name}</span></div>
              <Pill tone={ch.reviewed ? "success" : "warning"}>{ch.reviewed ? "Reviewed" : "New"}</Pill>
            </div>
            <div className="grid grid-cols-4 gap-2 mt-4 text-center">
              {[["Week", ch.week_rating], ["Sleep", ch.sleep], ["Energy", ch.energy], ["Stress", ch.stress]].map(([l, v]) => (
                <div key={l}><p className="label-xs">{l}</p><p className="font-heading text-2xl text-brand">{v}</p></div>
              ))}
            </div>
            <div className="mt-3 space-y-1.5 text-sm">
              <p><span className="text-tertiary">Went well:</span> {ch.went_well}</p>
              <p><span className="text-tertiary">Difficult:</span> {ch.difficult}</p>
              <p><span className="text-tertiary">Next focus:</span> {ch.focus_next}</p>
            </div>
            {ch.pain && <div className="mt-3"><Pill tone="danger">Reported pain</Pill></div>}
          </div>
        ))}
        {checkins.length === 0 && <p className="text-tertiary text-sm">No check-ins yet.</p>}
      </div>
    </div>
  );
}
